import {toCamelCaseProperties} from '@/utils/fn';

export default class WebshopProductDetail {
   constructor(args) {
      args = toCamelCaseProperties(args) || {};
      // var productDetails = toCamelCaseProperties(args.productDetails) || {};
      // var stock = []
      // productDetails.stockAmount.forEach(x => stock.push(toCamelCaseProperties(x)))
      this.odinProductId = args.odinProductId || -1;
      this.id = args.id;
      this.siteId = args.siteId || -1;
      this.title = args.name;
      this.price = args.price || 0;
      this.discounts = args.discounts|| []
      this.campaigns = args.campaigns || [];
      this.discounts = args.discounts|| []
      this.campaigns = args.campaigns || [];
      this.description = args.description;
      this.inventory = args.stockAmount ? args.stockAmount.find(x => x.siteId === args.siteId) || [] : args.productDetails.StockAmount ? args.productDetails.StockAmount.map(dataArgs => toCamelCaseProperties(dataArgs)) : [];
   }
}